<template>
  <d-page-layout
    @submitSearch="handleSubmitSearch"
    @clearSearch="handleClearSearch"
    :searchParamsCount="searchParamsCount"
  >
    <template slot="heading">
      <v-breadcrumbs class="pa-0" :items="items"></v-breadcrumbs>
    </template>
    <template slot="actions">
      <v-btn
        color="primary"
        depressed
        class="ml-2"
        @click="addOrEditModal = true"
      >
        <v-icon left> mdi-plus </v-icon>
        <span class="subtitle-2 text-none">{{
          $t("defaults.button.create")
        }}</span>
      </v-btn>
    </template>
    <template slot="search">
      <Search v-model="searchParams"></Search>
    </template>
    <template slot="content">
      <List
        :searchParams="searchParams"
        @edit="handleEdit"
        @changeStatus="handleChangeStatus"
      ></List>
      <AddOrEditModal
        v-if="addOrEditModal"
        :modal="addOrEditModal"
        :item="selectedItem"
        @closeModal="handleCloseAddOrEditModal"
        @submitModal="handleSubmitAddOrEditModal"
      ></AddOrEditModal>
      <ChangeStatusModal
        v-if="changeStatusModal"
        :modal="changeStatusModal"
        :item="selectedItem"
        @closeModal="handleCloseChangeStatusModal"
        @submitModal="handleSubmitChangeStatusModal"
      >
      </ChangeStatusModal>
    </template>
  </d-page-layout>
</template>
<script>
import Search from "./Search.vue";
import List from "./List.vue";
import AddOrEditModal from "./AddOrEditModal.vue";
import ChangeStatusModal from "./ChangeStatusModal.vue";

const initialSearchParams = {
  searchText: null,
  isActive: null,
  userTypeCode: null,
};

export default {
  components: {
    Search,
    List,
    AddOrEditModal,
    ChangeStatusModal,
  },
  data: (vm) => ({
    items: [
      {
        text: vm.$t("users.page-heading"),
        disabled: true,
      },
    ],
    searchParams: { ...initialSearchParams },
    addOrEditModal: false,
    changeStatusModal: false,
    selectedItem: null,
    searchParamsCount: 0,
  }),
  methods: {
    handleSubmitSearch() {
      this.searchParamsCount = this.getChangedFormItemsCount(
        this.searchParams,
        initialSearchParams
      );
      this.$eventBus.$emit("fetchUsers");
    },
    handleClearSearch() {
      this.searchParams = { ...initialSearchParams };
      this.handleSubmitSearch();
    },
    handleEdit(item) {
      this.selectedItem = item;
      this.addOrEditModal = true;
    },
    handleSubmitAddOrEditModal() {
      this.$eventBus.$emit("fetchUsers");
      this.handleCloseAddOrEditModal();
    },
    handleCloseAddOrEditModal() {
      this.selectedItem = null;
      this.addOrEditModal = false;
    },
    handleChangeStatus(item) {
      this.selectedItem = item;
      this.changeStatusModal = true;
    },
    handleSubmitChangeStatusModal() {
      this.$eventBus.$emit("fetchUsers");
      this.handleCloseChangeStatusModal();
    },
    handleCloseChangeStatusModal() {
      this.selectedItem = null;
      this.changeStatusModal = false;
    },
  },
  async mounted() {
    this.$eventBus.$emit("fetchUsers");
  },
};
</script>
